import React from "react";
import banner from "../../assets/projects/agentdesk_banner1.jpg";
import ss1 from "../../assets/screenshots/agentdeskss1.png"
import ss2 from "../../assets/screenshots/agentdeskss2.png"
import ss3 from "../../assets/screenshots/agenddeskadmin1.png"
import ss4 from "../../assets/screenshots/agenddeskadmin2.png"
import ss5 from "../../assets/screenshots/agentdeskagent1.png"
import ss6 from "../../assets/screenshots/agentdeskagent22.png"

const AgentDeskPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
  {/* Banner Image */}
  <section className="w-full">
    <img
      src={banner} // Replace with your actual image path
      alt="AgentDesk Banner"
      className="w-[500px] rounded-xl shadow-md object-cover"
    />
  </section>
  {/* Project Title & Overview */}
  <section>
    <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
      AgentDesk
    </h1>
    <p className="text-lg text-content lg:max-w-4xl">
    AgentDesk is an AI-powered customer support automation platform that streamlines ticket handling, agent assignment, and knowledge management. Built using n8n, Supabase, Airtable, and Bubble.io, it features AI agents for answering customer inquiries, escalating tickets, and intelligently routing them to the appropriate agents. It integrates with Gmail, Slack, and Airtable to automate communication and data storage. Human agents and admins manage tickets and knowledge through a dedicated web app that includes a ticket management system and a knowledge management system.
    </p>
  </section>

  {/* Technology Stack */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    💻 Technology Stack
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li><strong>n8n:</strong> AI automation, ticket processing, external integration</li>
      <li><strong>Supabase:</strong> Stores the document vector store and ticket vector store used by AI for answering questions</li>
      <li><strong>Airtable:</strong> Stores all ticket, customer, and agent data</li>
      <li><strong>Bubble.io:</strong> Web interface for human agents and admins</li>
      <li><strong>Gmail Integration:</strong> Sends ticket responses and notifications</li>
      <li><strong>Slack Integration:</strong> Chat-based management and agent notifications</li>
      <li><strong>ChatGPT (OpenAI):</strong> Core AI agent for natural language understanding, ticket generation, and knowledge retrieval</li>
<li><strong>Gemini (Google):</strong> Adds context to documents to support the AI's document understanding</li>
    </ul>

  </section>

  {/* AI Automation Features */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🤖 AI Automation Features (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Customer Support AI Agent that handles customer inquiries</li>
      <li>Automatically generates ticket title, description, and tags</li>
      <li>Escalates unresolved tickets to human agents</li>
      <li>Answers using 2 vector stores: document vector store & ticket vector store</li>
      <li>Smart Agent Assignment AI selects the most suitable human agent</li>
    </ul>
  </section>

  {/* Management via Slack */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      💼 Ticket, Human Agent & Customer Management via Slack (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Manage Tickets: Create, Read, Update, Delete</li>
      <li>Manage Customers: Create, Read, Update, Delete</li>
      <li>Manage Human Agents: Create, Read, Update, Delete</li>
    </ul>
  </section>

  {/* Knowledge Updater */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      📚 Knowledge Updater (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>After human agent responds, the answer is reviewed and inserted into the ticket vector store</li>
      <li>Admins can upload documents to automatically update the document vector store</li>
    </ul>
  </section>

  {/* Web App Interface */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🧑‍💻 Web App (Bubble.io)
    </h2>

    <h3 className="text-2xl font-semibold mt-6 mb-2">🔹 Human Agent Features</h3>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>View Ticket Dashboard</li>
      <li>View and Answer Tickets</li>
      <li>Update Availability and Slack ID</li>
    </ul>

    <h3 className="text-2xl font-semibold mt-6 mb-2">🔹 Admin Features</h3>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Upload Documents to Create Knowledge</li>
      <li>View and Delete Documents to Manage Knowledge</li>
    </ul>
  </section>

  {/* Screenshots */}
  <section>
  <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    🖼️ Project Images & Screenshots
  </h2>
  <div className="flex flex-col gap-6">
    <div>
      <p className="mb-2 font-medium">AI Customer Support Agent Workflow (n8n)</p>
      <a href={ss1} target="_blank" rel="noopener noreferrer">
        <img src={ss1} alt="Ticket Dashboard" className="w-full rounded-lg shadow" />
      </a>
    </div>
    <div>
      <p className="mb-2 font-medium">Ticket, Agent, and Customer Management Workflow (Slack + n8n)</p>
      <a href={ss2} target="_blank" rel="noopener noreferrer">
        <img src={ss2} alt="Agent Assignment Overview" className="w-full rounded-lg shadow" />
      </a>
    </div>
    <div>
      <p className="mb-2 font-medium">Admin Knowledge Management Dashboard</p>
      <a href={ss3} target="_blank" rel="noopener noreferrer">
        <img src={ss3} alt="Knowledge Management Interface" className="w-full rounded-lg shadow" />
      </a>
    </div>
    <div>
      <p className="mb-2 font-medium">Admin Knowledge Creation Page</p>
      <a href={ss4} target="_blank" rel="noopener noreferrer">
        <img src={ss4} alt="Knowledge Management Interface" className="w-full rounded-lg shadow" />
      </a>
    </div>

    <div>
      <p className="mb-2 font-medium">Human Agent Ticket Dashboard</p>
      <a href={ss5} target="_blank" rel="noopener noreferrer">
        <img src={ss5} alt="Knowledge Management Interface" className="w-full rounded-lg shadow" />
      </a>
    </div>

    <div>
      <p className="mb-2 font-medium">Human Agent Ticket Management Page</p>
      <a href={ss6} target="_blank" rel="noopener noreferrer">
        <img src={ss6} alt="Knowledge Management Interface" className="w-full rounded-lg shadow" />
      </a>
    </div>
    {/* Add more as needed */}
  </div>
</section>

</main>
);

export default AgentDeskPage;